import { Typography, Grid } from '@mui/material';
import { Page } from '../../../components';

export const BidManagement = () => {
  // const classes = useStyles();

  return (
    <Page title="Bid Management">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="body1">BidManagement</Typography>
        </Grid>
      </Grid>
    </Page>
  );
};

// const useStyles = makeStyles((theme: Theme) => ({
//   pageTitleWrapper: {
//     '@media (min-width: 768px)': {
//       flex: 1
//     }
//   }
// }));
